import React, { useEffect } from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Stack, styled } from "@mui/system";
import { getEmployeeAttendanceSummary } from "../../apiservices/attendance";
import moment from "moment";
import { TextStyle, Title } from "../dashboard/style";

window.Buffer = window.Buffer || require("buffer").Buffer;
const AttendanceSumary = ({ openPopup, closeSumaryPopup }) => {
  const style = {
    position: "absolute",
    // width: 900,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#FFFFFF",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.2)",
    borderRadius: "12px",
    p: 4,
  };
  const RowStyle = styled(Stack)({
    height: "80px",
    width: "800px",
    alignItems: "center",
    padding: "40px",
    borderRadius: "6px",
    margin: "25px",
    background: "#F8F8F8",
    color: "#67748E",
  });
  const currentMonthYear = moment().format("MM-YYYY");
  const updatedDate = moment().format("YYYY-MM");
  const [attendSumaryData, setAttendSumaryData] = useState({});
  const [filterMonth, setfilterMonth] = useState(updatedDate);

  useEffect(() => {
    getAttendanceSumary(currentMonthYear);
  }, []);
  const getAttendanceSumary = async (date) => {
    let data = {
      employeeId: localStorage.getItem("userId"),
      month: date,
    };
    let res = await getEmployeeAttendanceSummary(data);
    setAttendSumaryData(res);
  };
  const handleChange = async (e) => {
    setfilterMonth(e.target.value);
    const keyword = e.target.value;
    var updatedDate = keyword;
    updatedDate = updatedDate.split("-").reverse().join("-");
    getAttendanceSumary(updatedDate);
  };

  return (
    <div>
      <Modal
        open={openPopup}
        onClose={closeSumaryPopup}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Stack justifyContent="center" alignItems="center">
            <Title
              variant="h5"
              sx={{ fontWeight: "bold", color: "#04B2AE", m: 3 }}>
              Your Attendance Summary
            </Title>
            <input
              type="month"
              id="att_date_input"
              value={filterMonth}
              onChange={(e) => handleChange(e)}
              style={{ margin: 3 }}
            />
            <RowStyle
              direction="row"
              // alignItems="center"
              justifyContent="space-evenly">
              <Stack alignItems="center">
                <TextStyle>Total Presents</TextStyle>
                <TextStyle sx={{ color: "#00A455" }}>
                  {attendSumaryData.presents}
                </TextStyle>
              </Stack>
              <TextStyle
                type="title"
                color="inherit"
                style={{
                  borderRight: "2px solid #E3E3E3",
                  height: "4em",
                  color: "#E3E3E3",
                }}></TextStyle>
              <Stack alignItems="center">
                <TextStyle>Total Absents</TextStyle>
                <TextStyle sx={{ color: "#A40000" }}>
                  {attendSumaryData.absents}
                </TextStyle>
              </Stack>
              <TextStyle
                type="title"
                color="inherit"
                style={{
                  borderRight: "2px solid #E3E3E3",
                  height: "4em",
                  color: "#E3E3E3",
                }}></TextStyle>
              <Stack alignItems="center">
                <TextStyle>Total Leaves</TextStyle>
                <TextStyle sx={{ color: "#A0A400" }}>
                  {attendSumaryData.fullLeaves}
                </TextStyle>
              </Stack>
              <TextStyle
                type="title"
                color="inherit"
                style={{
                  borderRight: "2px solid #E3E3E3",
                  height: "4em",
                  color: "#E3E3E3",
                }}></TextStyle>
              <Stack alignItems="center">
                <TextStyle>Total Half Leaves</TextStyle>
                <TextStyle sx={{ color: "#D2AC23" }}>
                  {attendSumaryData.halfLeaves}
                </TextStyle>
              </Stack>
              <TextStyle
                type="title"
                color="inherit"
                style={{
                  borderRight: "2px solid #E3E3E3",
                  height: "4em",
                  color: "#E3E3E3",
                }}></TextStyle>
              <Box>
                <TextStyle>Total WFH</TextStyle>
                <TextStyle sx={{ color: "#0038A4" }}>
                  {" "}
                  {attendSumaryData.wfh}
                </TextStyle>
              </Box>
            </RowStyle>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default AttendanceSumary;
